import { render, staticRenderFns } from "./EstimatesOldPageCopyToModal.vue?vue&type=template&id=3b03f7e2&"
import script from "./EstimatesOldPageCopyToModal.vue?vue&type=script&lang=js&"
export * from "./EstimatesOldPageCopyToModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports